import { Button, Grid, Typography } from "@mui/material";

import styles from './index.module.css'
import PricingTable from "../../../PricingTable";


const NotesContainer = ({ notes }) => {

  return (
    <>
      <Grid container className={styles.headerContainer}>
        <Typography variant="h6" className={styles.title}>NOTES</Typography>
        <Typography variant="h6" className={styles.content}>{notes}</Typography>
      </Grid>
    </>

  )
}

export default NotesContainer